import { window } from "global";
import { MatchupsTable } from "./MatchupsTable";
import { TierListTablePlaceholder } from "@ugg/shared/components/TierList/common/TierListTablePlaceholder";
import { TierListTableError } from "@ugg/shared/components/TierList/common/TierListTableError";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params//valid-params";
import { getMatchups } from "@ugg/shared/api/data-parser/champions/matchups";
import { useChampionMatchups } from "@ugg/shared/api/requests/champions/matchups";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { normalizeRole } from "@ugg/shared/utils/role-helpers";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";

export function Matchups() {
  const { championId, role } = useChampionProfileContext();

  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.MATCHUPS, queryParams, true);
  const { data, loading, error } = useChampionMatchups(championId, { params: validatedQueryParams, ssr: true });
  const matchups = getMatchups(data, { ...validatedQueryParams, role: normalizeRole(role || "") });
  let filteredMatchups = (matchups && matchups.counters) || [];

  if (validatedQueryParams.allChampions !== "true") {
    filteredMatchups = filteredMatchups.filter((champion) => champion.pick_rate >= 0.5);
  }

  if (!window || loading) {
    return <TierListTablePlaceholder />;
  } else if (error) {
    return <TierListTableError />;
  } else {
    return <MatchupsTable data={filteredMatchups} championId={championId} role={role || ""} />;
  }
}
